module.exports = __webpack_public_path__ + "static/americanexpress.png";